import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { CuttingPlanService, StatusItem } from '@app/services/cutting-plan.service';
import { MatDialog } from '@angular/material/dialog';
import { CuttingplansChangeComponentComponent } from '../cuttingplans-change-component/cuttingplans-change-component.component';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'tt-cutting-plans',
    templateUrl: './cutting-plans.component.html',
    styleUrls: ['./cutting-plans.component.css'],
})
export class CuttingPlansComponent implements OnInit {
    public selectedBgCuttingPlansMain: string = 'CUTTINGPLANS';

    public setting?: Setting;

    public selectListStatuses: StatusItem[] = [];

    public selectListOperations: OperationItem[] = [];

    public grid?: GridOptions;

    public gridPows?: GridOptions;

    constructor(
        private stateService: StateService,
        private modal: ModalService,
        private dialog: MatDialog,
        private cuttingPlan: CuttingPlanService,
        private datatask: DataTaskService,
    ) {}

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2878))[0];
    }

    private async loadStatuses() {
        this.selectListStatuses = await this.cuttingPlan.getStatuses({ add_all: '1' });
        // this.selectListStatuses = await this.datatask.Post(2879);
    }

    private async loadOperations() {
        this.selectListOperations = await this.datatask.Post(4010);
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_cuttingplans_grid')
                .setLoadDataFunction({ method: 2884, parameters: () => this.setting })
                .addToolbarButton({ name: 'cuttingplans_new', text: 'cuttingplans_new', translate: true, icon: 'far fa-plus', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', func: this.addCuttingPlan })
                .addToolbarButton({ name: 'w_cuttingplan_delete', text: 'w_cuttingplan_delete', translate: true, icon: 'fad fa-trash', cssClass: 'tt-button tt-button--danger im-grid-btn-xs-r', func: this.deleteCuttingPlans, disable_if_no_selected: true });
            // .addToolbarButton({
            //     name: 'delete_selected:cu',
            //     icon: 'far-trash-alt',
            //     btn_type: 'danger',
            //     tooltip: 'delete_row',
            //     translateTooltip: true,
            //     func: async (data) => {
            //         const deleteConfirmed = await this.modal.openConfirmDialog({
            //             title: 'tt_delete_grid_row_title',
            //             translateMessage: true,
            //             message: 'tt_delete_grid_row_warning',
            //             type: 'danger',
            //         });

            //         if (deleteConfirmed) {
            //             await this.grid?.gridfunc?.removeRow(data);
            //             this.grid?.gridfunc?.saveChanges(false);
            //         }
            //     },
            // })

            // .addToolbarButton({
            //     name: 'cuttingplans_new',
            //     text: 'cuttingplans_new',
            //     translate: true,
            //     icon: 'fas fa-plus',
            //     cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
            //     func: async () => {
            //         const response = (await this.datatask.Post(2743, { table_name: 'cuttingplan' }))[0];

            //         this.stateService?.go('cuttingplan', { cuttingplan_keyno: response?.nextnumber });
            //     },
            // });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private loadGridPows() {
        if (!this.gridPows) {
            this.gridPows = new Grid()
                .setRememberId('w_cuttingplans_pows_grid')
                .setLoadDataFunction({ method: 4009, parameters: () => this.setting })
                .addToolbarButton({ name: 'w_cuttingplans_change_component', text: 'w_cuttingplans_change_component', translate: true, cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', func: this.changeComponent, disable_if_no_selected: true });
        } else {
            this.gridPows?.gridfunc?.read();
        }
    }

    private changeComponent = async () => {
        const rows = this.gridPows?.gridfunc?.getIsSelectedRows() ?? [];

        if (!this.gridPows || rows.length === 0) return;

        const { prod_id, prod_name } = await firstValueFrom(this.dialog.open(CuttingplansChangeComponentComponent).beforeClosed());

        let count = 0;
        let modalClosed = false;
        const progress = this.modal.openProgressDialog({ value: count, max: rows.length, rememberId: 'w_cuttingplans_grid.progress' });

        progress.dialogRef.beforeClosed().subscribe({ next: () => (modalClosed = true) });

        for (let row of rows) {
            try {
                if (modalClosed) break;

                const { errorcode, errormessage } = await this.cuttingPlan.updateCuttingPlanComponent({ comp_po_keyno: row['comp_po_keyno'], prod_id: prod_id });

                if ('' + errorcode !== '0') {
                    this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });

                    progress.updateStatus('invalid');
                    break;
                } else {
                    count++;
                    progress.updateValue(count);
                }

                if (count === rows.length) {
                    progress.updateStatus('finish');
                }
            } catch (error) {
                console.error(error);
                break;
            }
        }

        this.loadGridPows();
    };

    private addCuttingPlan = async () => {
        const response = (await this.datatask.Post(2743, { table_name: 'cuttingplan' }))[0];

        this.stateService?.go('cuttingplan', { cuttingplan_keyno: response?.nextnumber });
    };

    private deleteCuttingPlans = async () => {
        const rows = this.grid?.gridfunc?.getIsSelectedRows() ?? [];

        if (!this.grid || rows.length === 0) return;

        let count = 0;
        let modalClosed = false;
        const progress = this.modal.openProgressDialog({ value: count, max: rows.length, rememberId: 'w_cuttingplans_grid.progress' });

        progress.dialogRef.beforeClosed().subscribe({ next: () => (modalClosed = true) });

        for (let row of rows) {
            try {
                if (modalClosed) break;

                const { errorcode, errormessage } = await this.cuttingPlan.deleteCuttinglan({ cuttingplan_keyno: row['cuttingplan_keyno'] });

                if ('' + errorcode !== '0') {
                    this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });

                    progress.updateStatus('invalid');
                    break;
                } else {
                    count++;
                    progress.updateValue(count);
                }

                if (count === rows.length) {
                    progress.updateStatus('finish');
                }
            } catch (error) {
                console.error(error);
                break;
            }
        }

        this.loadGrid();
    };

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'cuttingplanstatus_no':
            case 'operation_id':
                if (this.setting!.bg_cuttingplans_main === 'CUTTINGPLANS') this.loadGrid();
                if (this.setting!.bg_cuttingplans_main === 'POPOWS') this.loadGridPows();
                break;
            default:
                break;
        }
    }

    public onTabChanged() {
        if (this.setting!.bg_cuttingplans_main === 'CUTTINGPLANS') this.loadGrid();
        if (this.setting!.bg_cuttingplans_main === 'POPOWS') this.loadGridPows();
    }

    private async init() {
        await this.loadSetting();
        this.loadStatuses();
        this.loadOperations();

        if (this.setting!.bg_cuttingplans_main === 'CUTTINGPLANS') this.loadGrid();
        if (this.setting!.bg_cuttingplans_main === 'POPOWS') this.loadGridPows();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    cuttingplanstatus_no: string;
    operation_id: string;
    bg_cuttingplans_main: string;
}

interface OperationItem {
    operation_id: string;
    operation_name: string;
    orderby: number;
}
